import React, { useEffect, useState, useCallback } from "react";
import appDetailStyle from "./AppDetail.module.css";
import { SidebarMenu } from "../Sidebar/SidebarMenu";
import { FirstAppHeader } from "../../Header/FirstAppHeader";
import { ButtonHover } from "../../ReuseableComp/ButtonHover";
import { useParams, useLocation, useHistory } from "react-router-dom";
import Credentials from "./Credentials";
import Overview from "./Overview";
import CustNInstNDownloadClient from "./CustNInstNDownloadClient";
import AppDataFetcher from "./Users";
import { MobileHeader } from "../../Header/MobileHeader";
import useIsMobile from "../AdminRoot/useIsMobile";
import { BillingPlans } from "../Billing Page/BillingPlans";
import ManageExtensions from "./BetaToggle/ManageExtension";
import LeadGenBotSettings from "./LeadGenBotSettings";

import GeneralSettings from "./GeneralSettings";

import ShareDeveloper from "./ShareDeveloper/index";
import TenantInvite from "./InviteSupportUser/TenantInvite";
import LeadGeneration from "./LeadGeneration/LeadGeneration";
import BottomActionBtn from "../../BottomActionBtn";
import AiAgentBotSettings from "./AiAgentBotSettings/index";
import LiveAgentBotSettings from "./LiveAgentBotSettings/index";
import ThemeSettings from "./ThemeSettings/index";

import FailedAIMsgs from "./FailedAIMsgs/index";
import Branding from "./Branding/index";

import GeneralAppSettings from "./GeneralAppSettings/index";
import AiAgentWorkFlow from "./AiAgentWorkFlow/IntentIndex";
import LeadGenWorkFlow from "./AiAgentWorkFlow/LeadGenIndex";

import APIConfig from "./AiAgentWorkFlow/APIConfigIndex";
import ChainApis from "./AiAgentWorkFlow/ChainApis";

import LoaderComp from "../../LoaderComp";
import WhiteLabelDomains from "./WhiteLabelDomains/WhiteLabelDomains";
import PreviewRoot from "../../Preview";
import { useTenantPlan } from "../../../hooks/useTenantPlan";
import AuthIntegration from "./AiAgentWorkFlow/AuthIntegration";
import UIFieldComponentsLibrary from "../UIFieldComponentsLibrary";
import OAuthConnections from "./AiAgentWorkFlow/OAuthConnections";
import ConnectorsPage from "./AiAgentWorkFlow/Connectors";

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;
console.log("domainBasedddddd on AppDEtailPage screen", backend_api_base_url);

// ============================================================================
// Global (tenant-scoped) tab IDs. Any tab in this list renders against
// `globalTenantContext` (no app_name), so downstream components treat
// themselves as running in global mode.
// ============================================================================
const GLOBAL_TAB_IDS = new Set([
  "Global API Configs",
  "Global API Chains",
  "Global Auth Integration",
  "Global Connections",
  "Global Tenant Settings",
]);

function mergeFeatures(features, betaToggle) {
  const merged = {};

  for (const key in features) {
    const feature = features[key];
    const beta = betaToggle[key] || {};

    merged[key] = {
      enable: beta.hasOwnProperty("enable") ? beta.enable : feature.enable,
      desc: beta.desc || feature.desc,
      settings: {},
      type: feature.type || beta.type || null,
    };

    // ✅ side_effects
    if (beta.side_effects || feature.side_effects) {
      merged[key].side_effects = beta.side_effects || feature.side_effects;
    }

    // ✅ sub_settings_enable
    if (
      beta.hasOwnProperty("sub_settings_enable") ||
      feature.hasOwnProperty("sub_settings_enable")
    ) {
      merged[key].sub_settings_enable = beta.hasOwnProperty(
        "sub_settings_enable",
      )
        ? beta.sub_settings_enable
        : feature.sub_settings_enable;
    }

    // ✅ beta_feature
    if (
      beta.hasOwnProperty("beta_feature") ||
      feature.hasOwnProperty("beta_feature")
    ) {
      merged[key].beta_feature = beta.hasOwnProperty("beta_feature")
        ? beta.beta_feature
        : feature.beta_feature;
    }

    // ✅ Merge settings
    const allSettingKeys = new Set([
      ...Object.keys(feature.settings || {}),
      ...Object.keys(beta.settings || {}),
    ]);

    for (const settingKey of allSettingKeys) {
      const featureSetting = feature.settings?.[settingKey] || {};
      const betaSetting = beta.settings?.[settingKey] || {};

      const mergedSetting = { ...featureSetting };

      for (const k in betaSetting) {
        mergedSetting[k] = betaSetting[k];
      }

      merged[key].settings[settingKey] = mergedSetting;
    }
  }

  return merged;
}

export const AppDetailPage = () => {
  const { plan: tenantPlan } = useTenantPlan();

  const isMobile = useIsMobile();
  const location = useLocation();
  const { region, app_name } = useParams();

  console.log(
    "region, app_namesdfsf is it not being updatedagainhere!!!!!!!",
    region.toUpperCase(),
    app_name,
  );
  console.log("locationdsfdf", location);

  // ⭐ FIX: Initialize activeItemId from location.state on first mount so
  //   that reloading a page (say, "Global API Configs") keeps you on it.
  //   If no hint exists, default to "Credentials".
  const [activeItemId, setActiveItemId] = useState(
    () => (location.state && location.state.activeItemId) || "Credentials",
  );
  const [appData, setAppData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);

  const globalSettings = JSON.parse(
    localStorage.getItem("global_features") || "{}",
  );

  console.log("wehrwerappDatatenantPladfn", appData);

  const mergedSettings = appData
    ? mergeFeatures(globalSettings.features || {}, appData.feature || {})
    : globalSettings;

  console.log("mergedSettingsssds", mergedSettings);

  // ⭐ PHASE 5: Global tenant context. Same shape as `appData` but with
  //   `app_name` deliberately omitted so the views (APIConfig, ChainApis,
  //   AuthIntegration, ConnectorsPage) know to operate in global context
  //   and only surface tenant-scoped items.
  const globalTenantContext = appData
    ? {
      region: appData.region,
      tenant_id: appData.tenant_id,
      tenant_info: appData.tenant_info,
      settings: appData.settings,
      feature: appData.feature,
      // No `app_name` — this is what makes downstream components treat
      // themselves as running in a global (tenant-scoped) context.
      // No `app_id` either, since a tenant-wide config isn't tied to
      // one app.
    }
    : null;

  // ─────────────────────────────────────────────
  // Patch appData locally after a successful update
  // in a child settings component.
  // ─────────────────────────────────────────────
  const handleAppDataPatch = useCallback((partial) => {
    setAppData((prev) => (prev ? { ...prev, ...partial } : prev));
  }, []);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 768);
  };

  useEffect(() => {
    checkMobileView();
    window.addEventListener("resize", checkMobileView);

    return () => window.removeEventListener("resize", checkMobileView);
  }, []);

  const toggleSidebar = () => {
    console.log("you click on back btn");

    if (isMobileView) {
      setIsSidebarOpen(!isSidebarOpen);
    }
  };

  const token = localStorage.getItem("token");

  const history = useHistory();

  useEffect(() => {
    const fetchAppData = async () => {
      const headersList = {
        Accept: "*/*",
        "User-Agent": "Thunder Client (https://www.thunderclient.com)",
        Authorization: token,
      };

      try {
        const region_prefix = region.toLowerCase();
        const response = await fetch(
          `https://${region_prefix}.apps2.${backend_api_base_url}/get_app?app_name=${encodeURIComponent(
            app_name,
          )}`,
          {
            method: "GET",
            headers: headersList,
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch app data.");
        }

        const data = await response.json();

        console.log("datasdsdfsdfsdhgfg", data);

        const featuresResponse = await fetch(
          `https://features2.${backend_api_base_url}/get_features`,
        );
        const featuresData = await featuresResponse.json();
        console.log(
          JSON.stringify(data.feature),
          "Features Response randomnlyyy:",
          JSON.stringify(featuresData.features),
        );
        const merged = mergeFeatures(featuresData.features, data.feature);
        console.log(
          "randomnlyyy this merged should also have `side_effects` and `hard_reset_required` values",
          JSON.stringify(merged),
        );

        data.feature = merged;

        console.log("wahteir this datlocation.statea?", data, location.state);
        setAppData(data);
        if (location.state && location.state.activeItemId) {
          setActiveItemId(location.state.activeItemId);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAppData();
  }, [app_name]);

  // ⭐ FIX: `activeWindowRightComponent` now knows whether the currently
  //   selected tab is a global (tenant-scoped) one. If so, it renders
  //   against `globalTenantContext` (no app_name) so the downstream
  //   components switch into global mode. Otherwise, it renders against
  //   `appData` (with app_name) exactly as before.
  const activeWindowRightComponent = (itemId, appDataFull) => {
    console.log("wawerweruwehrappData", appDataFull);
    if (!appDataFull) {
      return <div>No app data available</div>;
    }
    console.log("ehere you go", itemId);

    // ⭐ Choose context based on the tab ID.
    const isGlobalTab = GLOBAL_TAB_IDS.has(itemId);
    const ctx = isGlobalTab ? globalTenantContext : appDataFull;

    // ⭐ If the tab is global but we have no `globalTenantContext` (e.g. the
    //   app data hasn't loaded yet), render a friendly placeholder rather
    //   than crashing.
    if (isGlobalTab && !ctx) {
      return <div>Loading tenant context…</div>;
    }

    switch (itemId) {
      case "Overview":
        return <Overview appData={ctx} />;
      case "Credentials":
        return <Credentials appData={ctx} />;
      case "Manage Extensions":
        return (
          <ManageExtensions
            betaToggle={ctx.feature}
            region={ctx.region}
            app_name={ctx.app_name}
            tenant_name={ctx.tenant_id}
            tenant_id={ctx.tenant_info.id}
            app_type={ctx.settings.app_type}
            tenantPlan={tenantPlan}
          />
        );
      case "UI Field Components Library":
        return <UIFieldComponentsLibrary appData={ctx} />;

      case "LeadGen & FAQ":
        return (
          <LeadGenBotSettings
            appData={ctx}
            tenantPlan={tenantPlan}
            onAppDataPatch={handleAppDataPatch}
          />
        );

      case "AI Chat":
        return (
          <AiAgentBotSettings
            appData={ctx}
            tenantPlan={tenantPlan}
            onAppDataPatch={handleAppDataPatch}
            onTrainingComplete={async () => {
              const region_prefix = region.toLowerCase();
              const token = localStorage.getItem("token");

              try {
                const response = await fetch(
                  `https://${region_prefix}.apps2.${backend_api_base_url}/get_app?app_name=${encodeURIComponent(app_name)}`,
                  {
                    method: "GET",
                    headers: {
                      Authorization: token,
                      "Content-Type": "application/json",
                    },
                  },
                );

                if (!response.ok) {
                  throw new Error("Failed to fetch updated app data");
                }

                const data = await response.json();

                const featuresResponse = await fetch(
                  `https://features2.${backend_api_base_url}/get_features`,
                );
                const featuresData = await featuresResponse.json();
                const merged = mergeFeatures(
                  featuresData.features,
                  data.feature,
                );
                data.feature = merged;

                setAppData(data);

                console.log("✅ App data refreshed after training completion");
              } catch (error) {
                console.error("❌ Failed to refresh app data:", error);
              }
            }}
          />
        );

      case "Live Agent":
        return (
          <LiveAgentBotSettings
            appData={ctx}
            tenantPlan={tenantPlan}
            onAppDataPatch={handleAppDataPatch}
          />
        );

      case "Theme Settings":
        return <ThemeSettings appData={ctx} tenantPlan={tenantPlan} />;

      case "Connections":
        return <ConnectorsPage appData={ctx} />;

      case "Failed AI Messages":
        return <FailedAIMsgs appData={ctx} tenantPlan={tenantPlan} />;

      // ⭐ Workflows — switched to item.id values used by the sidebar,
      //   with backward-compatible aliases for the old text-based IDs.
      case "Skill Workflow":
      case "ai_agent_workflow":
        return <AiAgentWorkFlow appData={ctx} tenantPlan={tenantPlan} />;

      case "Leadgen Workflow":
      case "leadgen_workflow":
        return <LeadGenWorkFlow appData={ctx} tenantPlan={tenantPlan} />;

      case "Auth Integration":
        return <AuthIntegration appData={ctx} tenantPlan={tenantPlan} />;

      case "API Config":
        return <APIConfig appData={ctx} tenantPlan={tenantPlan} />;

      case "ChainApis":
        return <ChainApis appData={ctx} tenantPlan={tenantPlan} />;

      case "General Settings":
        return <GeneralAppSettings appData={ctx} tenantPlan={tenantPlan} />;

      case "Branding":
        return <Branding appData={ctx} tenantPlan={tenantPlan} />;

      case "App Users":
        return <AppDataFetcher appData={ctx} tenantPlan={tenantPlan} />;

      // ⭐ PHASE 4 + PHASE 5: Global (tenant-scoped) views.
      //
      // These render the same components as the app-scoped cases above,
      // but they receive `globalTenantContext` — an `appData`-shaped object
      // with no `app_name`. The components detect the absence of `app_name`
      // and:
      //   • fetch with `?include_tenant=true` (no app_name)
      //   • restrict their listing to tenant-scoped items
      //   • on save, write with scope="tenant" and no app_name
      case "Global API Configs":
        return (
          <APIConfig
            appData={globalTenantContext}
            tenantPlan={tenantPlan}
          />
        );

      case "Global API Chains":
        return (
          <ChainApis
            appData={globalTenantContext}
            tenantPlan={tenantPlan}
          />
        );

      case "Global Auth Integration":
        return (
          <AuthIntegration
            appData={globalTenantContext}
            tenantPlan={tenantPlan}
          />
        );

      // ⭐ NEW: Global Connections. The ConnectorsPage delegates to
      //   OAuthConnections + ConnectorDefinitionsPanel, both of which
      //   already handle `app_name === undefined` as "global context"
      //   (fetch with include_tenant only, no app_name).
      case "Global Connections":
        return (
          <ConnectorsPage
            appData={globalTenantContext}
            tenantPlan={tenantPlan}
          />
        );

      // Note: WILL ENABLE WHEN WE ARE BACK TO BUILDING Multi Admin
      case "Global Tenant Settings":
        return (
          <GeneralSettings
            betaToggle={globalTenantContext.feature}
            app_name={globalTenantContext.app_name}       /* undefined */
            tenant_name={globalTenantContext.tenant_id}
            tenant_id={globalTenantContext.tenant_info.id}
            app_type={globalTenantContext.settings.app_type}
          />
        );

      case "Share Integration Steps":
        return <ShareDeveloper appData={ctx} />;

      case "Invite Support User":
        return (
          <TenantInvite
            mode="invite"
            tenant_name={ctx.tenant_id}
            appData={ctx}
          />
        );

      case "Whitelabel Domains":
        return (
          <WhiteLabelDomains
            app_name={ctx.app_name}                        /* may be undefined */
            region={ctx.region}
            initialDomains={ctx.whitelabel_domains}
          />
        );

      case "User Support Permission":
        return <TenantInvite mode="manage" tenant_name={ctx.tenant_id} />;

      case "Plans & Billing":
        return <BillingPlans />;

      case "All Chats":
        history.push("/all_chats");
        break;

      default:
        return <div>No condition matched!!</div>;
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "90vh",
        }}
      >
        <LoaderComp />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <div className={appDetailStyle.mycontainer}>
        <div
          className={`${appDetailStyle.sidebar} ${isSidebarOpen ? appDetailStyle.open : ""
            }`}
        >
          <SidebarMenu
            activeItemId={activeItemId}
            setActiveItemId={setActiveItemId}
            appData={appData}
            toggleSidebar={toggleSidebar}
            isSidebarOpen={isSidebarOpen}
            mergedSettings={mergedSettings}
            tenantPlan={tenantPlan}
          />
        </div>

        <div
          className={`${appDetailStyle["main-content"]} ${isSidebarOpen ? appDetailStyle.hidden : ""
            }`}
        >
          {!activeItemId && <div>No Tab Selected</div>}
          {activeItemId && (
            <div className={appDetailStyle.mainContentInnerWrap}>
              {activeWindowRightComponent(activeItemId, appData)}
            </div>
          )}
        </div>
      </div>
    </>
  );
};